import { useTheme } from '@emotion/react'
import { Box, Grid, Rating, Typography } from '@mui/material'
import { FC } from 'react'
import { getPxAsRem } from 'shared/utils'

interface RatingsSummaryProps {
    ratingCount: number
    totalCount: number
    stats: {
        averageRating: number
        count: number
        noteType: string
    }[]
}

const RatingsSummary: FC<RatingsSummaryProps> = ({
    ratingCount,
    totalCount,
    stats,
}) => {
    const theme = useTheme()

    return (
        <Box
            padding={getPxAsRem(16)}
            width={getPxAsRem(297)}
            borderRadius={4}
            sx={{
                backgroundColor: theme.palette?.other?.lightGrey,
            }}
        >
            <Grid container alignItems={'center'} marginBottom={1}>
                <Grid item xs={6}>
                    <Typography fontWeight="600">Review Summary</Typography>
                </Grid>
                <Grid item xs={6} sx={{ textAlign: 'end' }}>
                    <Typography variant="caption" color="other.secondary_light">
                        {ratingCount} ratings
                        {totalCount !== ratingCount && ` (${totalCount} total)`}
                    </Typography>
                </Grid>
            </Grid>
            {stats.map((stat) => (
                <Box
                    key={stat.noteType}
                    marginTop={0.5}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        whiteSpace: 'nowrap',
                    }}
                >
                    <Typography variant="caption" sx={{ marginRight: 'auto' }}>
                        {stat.noteType} ({stat.count})
                    </Typography>
                    <Typography
                        marginRight={getPxAsRem(4)}
                        variant="caption"
                        // color="other.secondary_light"
                    >
                        {(stat.averageRating ?? 0).toFixed(1)}
                    </Typography>
                    <Rating
                        name="candidate-stars"
                        value={stat.averageRating ?? 0}
                        readOnly
                        precision={0.1}
                        size="small"
                    />
                </Box>
            ))}
        </Box>
    )
}

export default RatingsSummary
